import React, { useState } from 'react';
import { TeamOutlined, HomeOutlined, FrownOutlined, MenuOutlined } from '@ant-design/icons';
import { Menu } from 'antd';

const items = [
  {
    label: (
      <a href="/" style={{ textDecoration: 'none' }} rel="noopener noreferrer">
        Home
      </a>
    ),
    key: 'home',
    path: '/',
    icon: <HomeOutlined />
  },
  {
    label: (
      <a href="/shameList" style={{ textDecoration: 'none' }} rel="noopener noreferrer">
        Hall Of Shame
      </a>
    ),
    key: 'hallOfShame',
    path: '/shameList',
    icon: <FrownOutlined />
  },
  {
    label: (
      <a href="/about" style={{ textDecoration: 'none' }} rel="noopener noreferrer">
        About
      </a>
    ),
    path: '/about',
    key: 'about',
    icon: <TeamOutlined />
  }
];

const Navbar = () => {


  const [current, setCurrent] = useState('mail');
  const onClick = (e) => {
    console.log('click ', e);
    setCurrent(e.key);
  };
  return <Menu 
    theme="dark"      
    onClick={onClick} 
    electedkeys={[current]} 
    mode="horizontal" 
    items={items} 
    overflowedIndicator={<MenuOutlined />} 
    style={{
      flex: 1,
      minWidth: 0,
    }}/>;

}

export default Navbar